<template>
  <div>
    <!-- 面包屑导航 -->
    
    <div class="flex-spc-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="postion:fixed">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>操作员管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-link type="primary" style="margin-right:220px" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </div>
 
    <!-- 搜索筛选 -->

    <!--列表-->
       <el-form :inline="true" :model="formInline" class=" flex-r-x" style="width:100%;padding-top:30px">
         <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleEdit()">添加操作员</el-button>
      </el-form>

    <el-table  :data="tableData" highlight-current-row v-loading="loading"  size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
        <el-table-column  prop="Name" label="姓名"  >
          <template slot-scope="scope">
            <div class="flexc-cen-x">
              <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
              <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
              <div style="margin-left:5px;">{{scope.row.Name}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column  prop="Phone" label="联系电话" >
        </el-table-column>
        <el-table-column  prop="Note" label="备注" >
        </el-table-column>

        <!-- <el-table-column prop="addTime" label="创建时间" >
        </el-table-column>
        <el-table-column prop="ShopName" label="商户名称" >
        </el-table-column> -->
      <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" width="450" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.isAdmin ==1" disabled size="mini" type="primary" @click="setLimits(scope.row)" >权限配置</el-button>
          <el-button v-if="scope.row.isAdmin ==1" disabled  size="mini" type="success"  @click="setLimits1(scope.row)">员工权限</el-button>
          <el-button v-if="scope.row.isAdmin !=1" size="mini" type="primary" @click="setLimits(scope.row)" >权限配置</el-button>
          <el-button v-if="scope.row.isAdmin !=1" size="mini" type="success"  @click="setLimits1(scope.row)">员工权限</el-button>
          <el-popover placement="bottom" trigger="hover"   v-if="scope.row.isAdmin !=1" >
                <div class="">
                  <div class="flexc-cen-x cursor" style="height: 30px"  v-if="scope.row.Isdisable == 0 && scope.row.isAdmin !=1"   @click="handlejin(scope.row)">
                    <i class="el-icon-circle-close"></i>
                    <div style="margin-left: 10px; color: #65a8ff">禁用</div>
                  </div>
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="scope.row.Isdisable == 1 && scope.row.isAdmin !=1"   @click="handlejie(scope.row)">
                    <i class="el-icon-video-play"></i>
                    <div style="margin-left: 10px; color: #65a8ff">解禁</div>
                  </div>
              <div class="flexc-cen-x cursor" style="height: 30px"   @click="chongzhi(scope.row)">
                                  <i class="el-icon-refresh-right"></i>
                                  <div style="margin-left: 10px; color: #65a8ff">重置密码</div>
                </div>
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="scope.row.isAdmin !=1"  @click="deleteUser(scope.row)">
                    <i class="el-icon-delete"></i>
                    <div style="margin-left: 10px; color: #65a8ff">删除</div>
                  </div>
                </div>
                <el-button
                      style="margin-left:10px"
                  size="mini"     
                  slot="reference"
                >更多操作</el-button>
          </el-popover>
             <el-button
             v-if="scope.row.isAdmin ==1"
                  size="mini"     
                  slot="reference"
                  disabled
                >更多操作</el-button>

          <!-- <el-button v-if="scope.row.isAdmin ==1" draggable="" disabled type="warning" plain size="mini" @click="handlejin(scope.row)">禁用</el-button>
          <el-button size="mini" v-if="scope.row.isAdmin ==1" disabled type="info" @click="deleteUser(scope.row)">删除</el-button>
          <el-button v-if="scope.row.Isdisable == 0 && scope.row.isAdmin !=1" type="warning" plain size="mini" @click="handlejin(scope.row)">禁用</el-button>
          <el-button v-if="scope.row.Isdisable == 1 && scope.row.isAdmin !=1"  type="info" plain size="mini" @click="handlejie(scope.row)">解禁</el-button>
          <el-button size="mini" v-if="scope.row.isAdmin !=1" type="info" @click="deleteUser(scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <!-- 分页组件 -->

    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="30%" >
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" style="padding-bottom:80px">
        <el-form-item label="所属角色:" prop="Role" v-if="editForm.isAdmin !=1">
          <el-checkbox-group v-model="editForm.Role">  
            <el-checkbox v-for="item in roleList" :key="item.RType" :label="item.RoleName"   @change="change"></el-checkbox>
        </el-checkbox-group>
        </el-form-item>
        <el-form-item label="员工:"  v-if="title == '添加操作员'">
              <div class="flexc-cen-x" style="width:100%">
                  <div style="display:flex;flex-wrap:wrap;">
                      <div style="margin-left:5px">{{personName}}                    
                      </div>
                  </div>
                  <div>
                      <el-button bian  @click="toPerson()"  type="text" style="margin-right:10px;margin-left:10px">选择</el-button>
                      <!-- <el-button bian v-if="personName!=''"  @click="toDelPer()" icon="el-icon-delete"  type="text" style="margin-left:30px"></el-button> -->
                  </div>
                  
              </div>
            
            
        </el-form-item>
        <el-form-item label="员工:" v-else>
              <div class="flexc-cen-x" style="width:100%">
                  <div style="display:flex;flex-wrap:wrap;">
                      <div style="margin-left:5px">{{editForm.Name}}                    
                      </div>
                  </div>
                  <div> 
                  </div>
                  
              </div>
            
            
        </el-form-item>
        <!-- <el-form-item label="姓名:" prop="Name">
          <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
        </el-form-item> -->
        <el-form-item label="手机号:" prop="Phone"  v-if="editForm.isAdmin !=1">
          <span>{{editForm.Phone}}</span>
        </el-form-item>
        <el-form-item label="密码" prop="Pwd" v-if="title== '添加操作员'" >
          <el-input size="small" placeholder="请输入密码" v-model="editForm.Pwd" show-password auto-complete="off" style="width: 215px"></el-input>
        </el-form-item>

          <!-- <el-form-item label="操作员头像:" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrl !== ''">
                    <img
                      :src="editForm.HeadUrl"
                      style="height: 100px;width:100px"
                      alt="图片"
                        @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('HeadUrl')"
                  >
                   
                  
                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加头像"
                />
          </el-form-item> -->
          <!-- <el-form-item label="邮箱:" prop="Email">
          <el-input size="small" v-model="editForm.Email" auto-complete="off" placeholder="请输入邮箱"  style="width: 215px"></el-input>
        </el-form-item> 
        <el-form-item label="地址:" prop="Address">
          <el-input size="small" placeholder="请输入地址" v-model="editForm.Address" auto-complete="off" style="width:90%"></el-input>
        </el-form-item> -->
        <el-form-item label="备注:" prop="Note">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input>
        </el-form-item>

        <el-form-item label="员工权限:" prop="StaffIDs" v-if="title == '添加操作员'">
          <el-tree
            :data="personList"
            :props="props"
            show-checkbox
            ref="tree1"
            default-expand-all
            node-key="ID">
          </el-tree>
        </el-form-item>
      </el-form>

        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <!-- </el-dialog> -->
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
      <el-dialog title="充值" :visible.sync="chongShow" width="40%">
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>
                <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
             <cropper-image
                :Name="cropperName"
                @uploadImgSuccess="handleUploadSuccess"
                ref="child"
                :key="timer"
              >
              </cropper-image> 
            </el-dialog>
            <!--查看大封面-->
            <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
              <img
                :src="imgName"
                v-if="imgVisible"
                style="width: 100%"
                alt="查看"
              />
            </el-dialog>
    <el-drawer :wrapperClosable= false title="权限配置" :visible.sync="quanxian" :direction="direction" size="30%">
      <div style="padding-bottom:100px">
        <el-tree
              :data="typeList"
              :props="props"
              show-checkbox
              ref="tree"
           
              default-expand-all
              node-key="LType"
        >
        </el-tree>
      </div>

          <!-- @check ="chooseQuan" -->
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="quanxian = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
            @click="baocun"
            >保存</el-button
          >
        </div>
    </el-drawer>
        <el-drawer :wrapperClosable= false title="员工权限配置" :visible.sync="quanxian1" :direction="direction" size="30%">
          <el-tree
          :key="timer"
              :data="personList"
              :props="props1"
              show-checkbox
              ref="tree1"
              default-expand-all
              node-key="ID">
            </el-tree>
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="quanxian1 = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
            @click="baocun1"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <el-dialog title="选择员工" :visible.sync="personShow" width="500px" @click="passShow = false">
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flex-spc-x" style="margin-top:5px" > 
                            
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                            <el-button type="text">选择</el-button>
                        </div> 
                        
                    </div>
                </el-collapse-item>

            </el-collapse>

        </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
   quanxian:false,
   quanxian1:false,
    imgVisible:false,
    DianList:[],
          personShow:false,
  SelectStoresID:this.$route.params.id,
      direction: "ltr",
      cropperModel:false,
      passShow:false,
      money:'',
      timer:'',
      cropperName:'',
      input:'',
      timer:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      Pwd:'',
      props: {
          children: 'listsub',
          label: 'Name'
      },
      props1: {
          children: 'listsub',
          label: 'Name'
      },
      RoleID:'',
      
      editForm: {
        LoginName:"",
        Role:[],
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        HeadUrl:'',
        Email:'',
        Note:'',
        token: localStorage.getItem('token')
      },
      personList:[],
      roleList:[],
      // rules表单验证

      rules: {
        Role:[{type: 'array', required: true, message: '请选择所属角色', trigger: 'change' }],
        Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        Pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
          WZYGName:'',
    WZHYName:'',
    personName:'',
    WZXMName:'',
    WZPBName:'',
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.getType()
    this.getList()
    this.getRole()
    this.getPerson()
    this.getDianList()
      // this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      chongzhi(row){
       this.$confirm("确定要重置吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          LoginID:row.ID,
        }
        var that = this
        this.ajax('editLoginPwd.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "重置成功",duration:2000,
              });
              that.getList()
             
            }

        })
        })
        .catch(() => {
         
        });
    
    },
        toPerson(){
        this.personShow = true
    },
    choose(items){
      
          this.personName = items.Name
          this.editForm.Name = items.Name
          this.editForm.Phone = items.Phone
          this.editForm.HeadUrl = items.HeadUrl
          this.StaffID = items.ID

          this.personShow = false
       
          this.editForm.StaffID = items.ID
    },
    handlePassword1(){
        this.personShow = true
    },
    // chooseQuan(event){
    //   console.log(event)
    //    let selectNodes = this.$refs.tree.getCheckedNodes();
    //    console.log(selectNodes)
    // },
      tosetting(){
         this.$router.push({ path: '/setting/setting'})
      },
      changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.getType()
      this.getList()
      this.getRole()
      this.getPerson()
      this.getDianList()
    },
    getDianList(){
       var data = {   SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},
    getPerson(){
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),

      }
      
        var that = this
      this.ajax('getlistStaffgl.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.personList = res.data

          } 

      })
    },
    baocun(){
        let selectNodes = this.$refs.tree.getCheckedNodes();
                let NodeIDs = [];
                selectNodes.forEach((item,index) =>{
                    NodeIDs.push(item.LType);
                })
                let halfSelectNodes = this.$refs.tree.getHalfCheckedNodes();
                halfSelectNodes.forEach(item=>{
                    NodeIDs.push(item.LType)
                })
        let allStr = NodeIDs.join(",");
                         var data = { SelectStoresID:this.SelectStoresID,
                                token:localStorage.getItem("token"),
                                StoresID:localStorage.getItem("StoresID"),
                                LoginID:this.RoleID,
                                Limits:allStr
                        }
              
                  var that = this
                          this.ajax('editLoginLimits.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.quanxian = false
                                  that.getList()
                                }

                            })

              
        // console.log(allStr)
      },
    baocun1(){
        let selectNodes = this.$refs.tree1.getCheckedNodes();
                let NodeIDs = [];
                selectNodes.forEach((item,index) =>{
                    NodeIDs.push(item.ID);
                })
                let halfSelectNodes = this.$refs.tree1.getHalfCheckedNodes();
                halfSelectNodes.forEach(item=>{
                 //   NodeIDs.push(item.ID)
                })
        let allStr = NodeIDs.join(",");
                         var data = { SelectStoresID:this.SelectStoresID,
                                token:localStorage.getItem("token"),
                                StoresID:localStorage.getItem("StoresID"),
                                LoginID:this.RoleID,
                                StaffIDs:allStr
                        }
              
                  var that = this
                          this.ajax('editLoginStaffIDs.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.quanxian1 = false
                                  that.getList()
                                }

                            })

              
        // console.log(allStr)
      },
          setLimits1(items){
            // this.selectedUserId = items.ID;
            this.timer = new Date().getTime()
            this.RoleID = items.ID
            this.quanxian1 = true;
            let setNodes = [];
            let setIds = [...items.StaffIDs.split(',')]
            setIds.forEach((item,index) =>{
              // console.log('item',item)

                    this.personList.forEach((node,k) =>{
                        if(node.listsub.length>0){
                            for(let i in node.listsub){
                                if(node.listsub[i].ID == item){
                                    setNodes.push(node.listsub[i])
                                }
                            }
                        } else {
                            if(node.ID == item){
                                setNodes.push(node)
                            }else{
                                return;
                            }
                        }  
                    });
                });

              //   console.log('setNodes',setNodes)

              // console.log('setIds',setIds)
                this.$nextTick(function () {
                    // this.$refs.tree.setCheckedNodes(setNodes,true);
                    this.$refs.tree1.setCheckedKeys(setIds,true);
                })
            },
        setLimits(items){
            // this.selectedUserId = items.ID;
           this.RoleID = items.ID
            console.log(items.Limits)
            this.quanxian = true;
            let setIds = items.Limits.split(',');
            var set =items.Limits.split(',')
              setIds.forEach((node,index) => {
                this.typeList.forEach(items =>{
                    let itemsList = items.listsub
                    if(itemsList.length > 0){
                      if( node == items.LType){
                            set[index] = 0
                      }
                        
                          itemsList.forEach(item => {
                              if(item.LType == node && item.listsub.length >0){
                                  
                                 set[index] = 0  
                                  
                              }       
                                   
                                  //
                        });
                        
                    }    
            });
    

              
              })   
              console.log(set)
            this.$nextTick(function () {
                  this.$refs.tree.setCheckedKeys( set,true);
                })
            },
        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          LoginID:row.ID,
        
        }
        var that = this
        this.ajax('delLogin.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
 
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    change(event){
        console.log(event)
        console.log(this.Role)
    },
    uploadPicture(name) {
        this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
     handleUploadSuccess(data) {
          this.cropperModel = false
          this.editForm.HeadUrl = data.url
 
  },
    getRole(){
    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
      }
     
        var that = this
      this.ajax('getListRole.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.roleList = res.data
              
          } 

      })
  
   
    },
    getType(){
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
     
      }
      var that = this
      this.ajax('getListLimits.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
    },
    getList(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,

      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListLogin.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.pageparm.total = res.allcount

                 loading.close();
          } 

      })
  
    },

    handlePassword(row){
      this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit(row) {
       var that = this
      if (row != undefined && row != 'undefined') {
        this.title = '修改操作员'

        that.editForm = row
        if(row.Role != 0){
              console.log(this.editForm.Role)
          const list = this.editForm.Role.split(",")
          const list1 = []
          list.forEach(item => {
              this.roleList.forEach(items => {
                   if(item == items.RType)
                           list1.push(items.RoleName)
                })
            })
            that.editForm.Role = list1
    
        } else {
          that.editForm.Role = []
        }
       
      } else {
        this.title = '添加操作员'
        this.personName = '',
        this.editForm = {
          Phone:"",
          Name:"",
          Pwd:'',
          HeadUrl:'',
          StaffID:'',
          Email:'',
          Note:'',
          Role:[],
        }
      }
      this.editFormVisible = true
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      

         var list = []
         if(this.editForm.Role.length >0){
            this.editForm.Role.forEach(item => {
                    this.roleList.forEach(items => {
                          if(item == items.RoleName)
                              list = list + items.RType +','
                      })
            })
            list=list.substr(0,list.length-1)
            console.log(list)
         }
        
      this.$refs[editData].validate(valid => {
        if (valid) {
          var data =this.editForm
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")

              if(list.length == 0){
                  data.Role = ''
              } else {
                  data.Role = list
              }
              
              data.SelectStoresID = this.SelectStoresID
              var that = this
            if(this.title == '添加操作员'){
                let selectNodes = this.$refs.tree1.getCheckedNodes();
                let NodeIDs = [];
                selectNodes.forEach((item,index) =>{
                    NodeIDs.push(item.ID);
                })
                let halfSelectNodes = this.$refs.tree1.getHalfCheckedNodes();
                halfSelectNodes.forEach(item=>{
                    NodeIDs.push(item.ID)
                })
        let allStr = NodeIDs.join(",");
                data.StaffIDs = allStr
                this.ajax('addLogin.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })

            }else {
                data.LoginID=  this.editForm.ID
                 this.ajax('editLogin.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    
    
    },
handlejin(row){
 this.$confirm("确定要禁用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          LoginID:row.ID,
          Isdisable:1
        }
        var that = this
        this.ajax('editLoginisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "禁用成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
         
        });
   
},
handlejie(row){
 this.$confirm("确定要启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          LoginID:row.ID,
          Isdisable:0
        }
        var that = this
        this.ajax('editLoginisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "启用成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
       
        });
   
},
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
      this.getList()
      this.editForm = {
          Phone:"",
          Name:"",
          Pwd:'',
          HeadUrl:'',
          Email:'',
          Note:'',
          Role:[],
        }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/operator/operator.vue